// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FbPR","top":"styles_top__3DRbE"};